import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import SignatureCard from '../components/modal/SignatureCard';
import profileImage from '../images/profile-image.svg';
import iconCalendar from '../images/icon-calendar-black.svg';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import * as securityHelper from "../helper/SecurityHelper";
import CustomDatePicker from "../components/ui/DatePicker";
import ChgPswrd from "../components/modal/ChgPswrd";
import Snackbar from "../components/Snackbar";
import axios from "axios";
import { USER_SESSION } from "../helper/SecurityHelper";
import ChgImg from '../components/modal/ChgImg';
import iconUpload from "../images/icon-upload.svg";

interface Evnt {
  evntNm: string;
  prepStrtDt: string;
  prepEndDt: string;
  evntStrtDt: string;
  evntEndDt: string;
  dmlnStrtDt: string;
  dmlnEndDt: string;
}
interface History {
  cmpnyNm: string;
  evnt: Evnt[];
};

export default function Mypage() {
  const navigate = useNavigate();
  const [signatureCard, setSignatureCard] = useState(false);
  const [signature, setSignature] = useState('');
  const [history, setHistory] = useState<History[]>();
  const outputRef = useRef<HTMLImageElement>(null);
  const comRefs = useRef({}) as React.MutableRefObject<any>;
  const arrowDownRefs = useRef({}) as React.MutableRefObject<any>;
  const arrowUpRefs = useRef({}) as React.MutableRefObject<any>;
  const user: any = securityHelper.getLoginUser();
  const [datePopup, setDatePopup] = useState(false);
  const datePopupOpen = () => { setDatePopup(!datePopup); };
  const prodRef = useRef<any>();
  const [position, setPosition] = useState(user.position);
  const [date, setDate] = useState<Date>(new Date());
  const [dateView, setDateView] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const cnstrFileRef = useRef() as React.MutableRefObject<any>;
  const [fileName, setFileName] = useState('');
  const [cnstrFileNm, setCnstrFileNm] = useState('');
  const [cnstrFileSrc, setCnstrFileSrc] = useState('');
  const [fileSrc, setFileSrc] = useState('');
  const [isOpenPswrdPop, setIsOpenPswrdPop] = useState(false);
  const [newPw, setNewPw] = useState('');
  const [snackbarTxt, setSnackbarTxt] = useState('');

  useEffect(() => {
    if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 2000) }
  }, [snackbarTxt]);

  useEffect(() => {
    if (newPw) {
      setSnackbarTxt('새 비밀번호가 설정 되었습니다.')
    }
  }, [newPw])
  //
  // useEffect(() => {
  //   if (user.auth !== 'KOX') {
  //     const cnstrFileList = cnstrFileRef.current.files;
  //     let imgSrc;
  //
  //     console.log('cnstrFileList: ', cnstrFileList);
  //     if (cnstrFileList.length > 0) {
  //       imgSrc = URL.createObjectURL(cnstrFileList[0]);
  //       console.log('imgsrc: ', imgSrc)
  //       setCnstrFileSrc(imgSrc);
  //     }
  //   }
  // }, [cnstrFileNm])

  const foldHandler = (param: any) => {
    if (comRefs.current[param].hidden === true) {
      comRefs.current[param].hidden = false;
      arrowUpRefs.current[param].hidden = false;
      arrowDownRefs.current[param].hidden = true;
    } else {
      comRefs.current[param].hidden = true;
      arrowDownRefs.current[param].hidden = false;
      arrowUpRefs.current[param].hidden = true;
    };
  };
  useEffect(() => {
    if (outputRef.current !== null) {
      outputRef.current.src = signature
    };
  }, [signature, outputRef]);
  useEffect(() => {
    let birthDay = user.birthday;
    if (birthDay && birthDay.length === 8) {
      birthDay = birthDay.substring(0, 4) + '.' + birthDay.substring(4, 6) + '.' + birthDay.substring(6, 8);
    }
    birthDay = new Date(birthDay);
    setDate(birthDay);

    if (user.sign) {
      setSignature(user.sign);
    }

    if (user.auth === 'COM') {
      retrieveHstCmpnyHistDataList();
    } else if (user.auth === 'SRV' || user.auth === 'WOK') {
      retrieveSrvCmpnyHistDataList();
    }

  }, [])

  useEffect(() => {
    let year = date.getFullYear();
    let month: number = date.getMonth() + 1;
    let day = date.getDate();
    setDateView(`${year}. ${month >= 10 ? month : '0' + month}. ${day >= 10 ? day : '0' + day}`);
  }, [date]);

  const retrieveHstCmpnyHistDataList = async () => {
    const rtrnData = await axios.post('admin/api/user/retrieveHstCmpnyHistDataList', { userSeq: user.seq });
    setHistory(rtrnData.data)
  }

  const retrieveSrvCmpnyHistDataList = async () => {
    const rtrnData = await axios.post('admin/api/user/retrieveSrvCmpnyHistDataList', { userSeq: user.seq });
    setHistory(rtrnData.data)
  }

  const fn_fileHandler = () => { fileRef.current.click(); }
  // const fn_cnstrFileHandler = () => { cnstrFileRef.current.click(); };

  const fn_save = async () => {
    const fileList = fileRef.current.files;
    // const cnstrFileList = cnstrFileRef.current.files;
    const formData = new FormData();

    if (fileList.length > 0) {
      formData.append('multipartFiles', fileList[0]);
    }
    // if (cnstrFileList.length > 0) {
    //   formData.append('cnstrFiles', cnstrFileList[0]);
    // }

    const jsonObject = {
      userSeq: user.seq,
      date: date,
      sign: signature,
      inputPassword: newPw,
      position: position
    };

    formData.append('jsonData', JSON.stringify(jsonObject));

    let rtrnData = await axios.post('admin/api/user/updateUserInfo', formData);
    if (rtrnData.data > 0) {
      setSnackbarTxt('저장 되었습니다.')
      rtrnData = await axios.post('admin/api/user/findUserBySeq', { userSeq: user.seq });
      sessionStorage.setItem(USER_SESSION, JSON.stringify(rtrnData.data));
      setTimeout(() => window.location.reload(), 1000);
    }
  }

  useEffect(() => {
    if (fileRef.current) {
      const fileList = fileRef.current.files;
      let imgSrc;
      if (fileList.length > 0) {
        imgSrc = URL.createObjectURL(fileList[0]);
        setFileSrc(imgSrc);
      }
    }
  }, [fileName])

  return (
    <div className='w-screen h-[calc(100dvh)] relative z-20'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      {signatureCard && <SignatureCard setSignature={setSignature} setSignatureCard={setSignatureCard} outputRef={outputRef} />}
      {isOpenPswrdPop && <ChgPswrd setIsOpenPswrdPop={setIsOpenPswrdPop} setNewPw={setNewPw} />}

      <NavbarText backEvent={() => navigate(-1)}>마이페이지</NavbarText>
      <div className='sticky top-52 h-120 md:top-[130px] md:h-[300px] flex items-center'>
        <img src={user.prflAtchFileId && !fileName ? 'admin/api/cmmn/fileDownload?atchFileId=' + user.prflAtchFileId + '&fileSn=0' : fileName ? fileSrc : profileImage} alt='profile' className='w-77 h-77 md:w-[192px] md:h-[192px] rounded-full bg-white ml-13 mr-10 sm:ml-28 sm:mr-20 md:ml-[70px] md:mr-[50px]' />
        <div className='flex flex-col justify-center'>
          <p className='text-17 leading-20 font-preBold mb-10 md:text-42 md:leading-[50px] md:mb-[25px]'>{user.name} <span>님</span></p>
          <div className='flex'>
            <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
            <button onClick={() => fn_fileHandler()} className='w-67 h-32 text-14 leading-16 md:w-[167px] md:h-[80px] md:text-35 md:leading-[40px] font-preLight rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo mr-9 md:mr-[22px]'>사진변경</button>
            {user.auth !== 'WOK' && <button className='w-88 h-32 text-14 leading-16 md:w-[220px] md:h-[80px] md:text-35 md:leading-[40px] font-preLight rounded-[5px] md:rounded-[12px] bg-[#3A3A3F]' onClick={() => (setIsOpenPswrdPop(true))}>비밀번호변경</button> }
          </div>
        </div>
      </div>
      <div className='h-[calc(100%-172px)] md:h-[calc(100%-430px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'>
        <div className='w-[260px] sm:w-[318px] md:w-[750px] mb-20 md:mb-[50px]'>
          <p className='mt-30 ml-10 mb-12 md:mt-[75px] md:ml-[25px] md:mb-[30px] font-preBold text-15 md:text-37'>휴대폰번호</p>
          <div className='flex items-center justify-between'>
            <input value={user.phone?.length === 11 ? user.phone.substring(0, 3) + '-' + user.phone.substring(3, 7) + '-' + user.phone.substring(7, 11) : user.phone} className='w-[185px] sm:w-[239px] md:w-[597px] h-30 md:h-[75px] pl-20 md:pl-[50px] text-15 md:text-37 font-preLight outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#CACACA]' />
            <button className='w-64 h-30 md:w-[160px] md:h-[75px] rounded-[4px] md:rounded-[10px] bg-[#F2F4F6] text-13 leading-15 md:text-[32px] md:leading-[37px] text-[#9C9C9B] font-preLight'>인증완료</button>
          </div>
          {/*<p className='mt-25 ml-10 mb-12 md:mt-[62px] md:ml-[25px] md:mb-[30px] font-preBold text-15 md:text-37'>생년월일</p>*/}
          {/*<div onClick={datePopupOpen} ref={prodRef} className='w-full h-27 md:h-[67px] flex justify-between items-center pl-20 md:pl-[50px] text-15 md:text-37 font-preLight border border-x-0 border-t-0 border-b-[0.5px] border-b-[#CACACA]'>*/}
          {/*  {dateView}*/}
          {/*  <img className='mr-18 md:mr-[45px] md:w-[40px]' src={iconCalendar} alt='calendar' />*/}
          {/*</div>*/}
          {/*{datePopup*/}
          {/*  ? <div className='relative'>*/}
          {/*    <CustomDatePicker date={date} setDate={setDate} setDateView={setDateView} setDatePopup={setDatePopup} prodRef={prodRef} />*/}
          {/*  </div>*/}
          {/*  : null}*/}
          {/*<div className='mt-5 md:mt-[12px] flex items-center justify-between'>*/}
          {/*  <p className='mt-25 ml-10 mb-12 md:mt-[62px] md:ml-[25px] md:mb-[30px] font-preBold text-15 h-34 md:text-37 md:h-[85px]'>직책</p>*/}
          {/*  <input value={position} onChange={(e: any) => setPosition(e.target.value)} className='w-[185px] sm:w-[75%] h-34 md:h-[85px] pl-10 md:pl-[25px] text-15 md:text-37 font-preLight outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#CACACA]' />*/}
          {/*</div>*/}
          <p className='mt-10 ml-10 mb-12 md:mt-[25px] md:ml-[25px] md:mb-[30px] font-preBold text-15 md:text-37'>전자서명</p>
          {signature
            ? <img src="//:0" alt="" ref={outputRef} onClick={() => setSignatureCard(true)} className='w-full h-142 md:h-[355px] rounded-[5px] md:rounded-[12px] border border-[#D9D9D9] mt-11 md:mt-[27px]' />
            : <div onClick={() => setSignatureCard(true)} className='w-full h-142 md:h-[355px] rounded-[5px] md:rounded-[12px] border border-[#DBDBDB] flex items-center justify-center relative'>
              {/* 유저 sign 이미지 파일 가져오기 */}
              <p className='absolute text-13 leading-13 font-preLight text-[#DBDBDB] top-10 right-10'>*클릭하여 수정해주세요.</p>
            </div>}
          {/*{user.auth !== 'KOX' && <>*/}
          {/*  <p className='ml-8 mt-30 md:ml-[20px] md:mt-[75px] md:text-37'>건설기초안전 이수증 첨부 {user.cnstrAtchFileId ? '(완료)' : null}</p>*/}
          {/*  {user.cnstrAtchFileId && !cnstrFileSrc ? <img src={'admin/api/cmmn/fileDownload?atchFileId=' + user.cnstrAtchFileId + '&fileSn=0'} onClick={fn_cnstrFileHandler} alt='' className='w-[235px] h-129 md:w-[587px] md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />*/}
          {/*    : !cnstrFileNm*/}
          {/*      ? <button onClick={fn_cnstrFileHandler} className='mt-18 ml-8 md:mt-[45px] md:ml-[20px] flex justify-center items-center w-148 h-49 md:w-[370px] md:h-[122px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>*/}
          {/*        <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />*/}
          {/*        <p>파일 올리기</p>*/}
          {/*      </button>*/}
          {/*      : <img onClick={fn_cnstrFileHandler} src={cnstrFileSrc} alt='cnstrImg' className='object-cover px-3 py-3 md:px-[7px] md:py-[7px]' />}*/}
          {/*  <input hidden onChange={(e) => setCnstrFileNm(e.target.value.substring(12))} type='file' ref={cnstrFileRef} />*/}
          {/*</>}*/}
          {user.auth !== 'KOX' && <>
            <div className='flex items-center justify-between mt-17 md:mt-[42px]'>
              {user.auth !== 'WOK'
                ? <><p className='ml-10 md:ml-[25px] font-preBold text-15 md:text-37'>근로이력</p>
                  <button className='w-64 h-34 md:w-[160xp] md:h-[85px] rounded-[4px] md:rounded-[10px] bg-[#F2F4F6] text-13 leading-15 md:text-32 md:leading-[37px] text-[#9C9C9B] font-preLight hidden'>회사변경</button></>
                : <><p className='ml-10 md:ml-[25px] font-preBold text-15 md:text-37'>소속 정보(행사 정보)</p>
                  <button className='w-64 h-34 md:w-[160xp] md:h-[85px] rounded-[4px] md:rounded-[10px] bg-[#F2F4F6] text-13 leading-15 md:text-32 md:leading-[37px] text-[#9C9C9B] font-preLight hidden'>회사추가</button></>}
            </div>
            {history?.map((history, idx) => {
              return (
                <div key={idx}>
                  <button onClick={() => foldHandler(history.cmpnyNm)} className='flex justify-between items-center border-none w-[260px] sm:w-[318px] md:w-[750px] h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] mt-17 md:mt-[42px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
                    <p className='text-15 md:text-37 font-preBold ml-20 md:ml-[50px]'>{history.cmpnyNm}</p>
                    <div ref={(el) => arrowDownRefs.current[history.cmpnyNm] = el}><IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' /></div>
                    <div hidden ref={(el) => arrowUpRefs.current[history.cmpnyNm] = el}><IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' /></div>
                  </button>
                  <div ref={(el) => comRefs.current[history.cmpnyNm] = el}>
                    {history.evnt.map((evnt, idx) => {
                      return (
                        <div key={idx}>
                          <div className='flex items-center mt-15 md:mt-[37px] ml-13 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
                            <p className='font-preBold mr-24 sm:mr-30 md:mr-[75px]'>행사명</p>
                            <p>{evnt.evntNm}</p>
                          </div>
                          <div className='flex items-center mt-15 md:mt-[37px] ml-13 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
                            <p className='font-preBold mr-24 sm:mr-30 md:mr-[75px]'>준비기간</p>
                            <p>{evnt.prepStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.prepEndDt}</p>
                          </div>
                          <div className='flex items-center mt-15 md:mt-[37px] ml-13 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
                            <p className='font-preBold mr-24 sm:mr-30 md:mr-[75px]'>행사기간</p>
                            <p>{evnt.evntStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.evntEndDt}</p>
                          </div>
                          <div className='flex items-center mt-15 md:mt-[37px] ml-13 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
                            <p className='font-preBold mr-24 sm:mr-30 md:mr-[75px]'>철거기간</p>
                            <p>{evnt.dmlnStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.dmlnEndDt}</p>
                          </div>
                          {idx !== (history.evnt.length - 1) && <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-20 md:mt-[50px]' />}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </>}
        </div>
        <button onClick={fn_save} className='text-white text-15 md:text-37 font-preLight w-[255px] sm:w-[308px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto px-10 py-10 md:px-[25px] md:py-[25px] mb-20 md:mb-[50px]'>저장</button>
      </div>
    </div>
  );
}

